module.exports = "<alert></alert>\r\n<div class=\"row wrapper border-bottom white-bg page-heading\">\r\n    <div class=\"col-lg-10\">\r\n        <h2>Audit Reports</h2>\r\n        <ol class=\"breadcrumb\">\r\n            <li>\r\n                <a [routerLink]=\"['/admin/home']\">Admin</a>\r\n            </li>\r\n            <li class=\"active\">\r\n                <strong>Audit Report</strong>\r\n            </li>\r\n        </ol>\r\n    </div>\r\n    <div class=\"col-lg-2\"></div>\r\n</div>\r\n<audit-report-table></audit-report-table>"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/admin/audit-report/audit-report-management.html
// module id = 1099
// module chunks = 0